import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";


import { toast } from "react-toastify";
const SalaryHeadForm = (props) => {
  const frmRef = useRef({});

  const [salaryHeadData, setSalaryHeadData] = useState([]);
  const [calculationAs, setCalculationAs] = useState([]);
  const [calculationType, setCalculationType] = useState([]);
  const { sendRequest: postSalaryHead } = useHttp();
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const offset = currentPage * itemsPerPage;
  const displayedItems =
    salaryHeadData && salaryHeadData.slice(offset, offset + itemsPerPage);
 

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      salaryHeadName: frmRef.current.salaryHeadName.value.trim(),
      calculationType: calculationType,
      calculationOn: calculationAs,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };

   

    postSalaryHead(
      {
        url: "/api/salaryHead/",
        method: props.update ? "PUT" : "POST",
    
        body: data,
      },
      (data) => {
        toast.success("Salary head name detail added");
         props.addForm(false);
      }
    );
  };
 

  return (
    <>
      <div className="content-wrapper">
        <div>
          &nbsp;
        </div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Salary Head Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Salary Head Name</label>
                        <input
                type={"text"}
                id={"salaryHeadName"}
                required
                ref={(el) => (frmRef.current["salaryHeadName"] = el)}
                className="form-control"
              />
                        
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                      <label>Calculation Type </label>
                      <select
                id="calculationType"
                className="form-control"
                ref={(el) => (frmRef.current["calculationType"] = el)}
                required
                onChange={(e) => {
                  setCalculationType(e.target.value);
                }}
              >
                <option selected value="">
                  --Select--
                </option>
                <option>Add </option>
                <option>Deduct </option>
              </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                      <label>    Calculation As </label>


                      <select
                id="calculationAs"
                className="form-control"
                ref={(el) => (frmRef.current["calculationAs"] = el)}
                required
                onChange={(e) => {
                  setCalculationAs(e.target.value);
                }}
              >
                <option selected value="">
                  --Select--
                </option>
                <option value="Fixed">Fixed </option>
                <option value="Percentage">Percentage</option>
              </select>
                      </div>
                    </div>
                  </div>
                

                    
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default SalaryHeadForm;
